import {BookingsMutation} from "./types";
import {STATUS_ERROR, STATUS_LOADING, STATUS_SUCCESS} from "../const";

export default {
    [BookingsMutation.REQUEST](state) {
        state.status = STATUS_LOADING;
        state.inquiries = {
            items: [],
            total: 0,
        };
        state.bookings = {
            items: [],
            total: 0,
        };
    },
    [BookingsMutation.SUCCESS_INQUIRY](state, data) {
        state.status = STATUS_SUCCESS;

        state.inquiries = data;
    },
    [BookingsMutation.SUCCESS_BOOKINGS](state, data) {
        state.status = STATUS_SUCCESS;

        state.bookings = data;
    },
    [BookingsMutation.ERROR](state, error) {
        state.status = STATUS_ERROR;
        state.lastError = error;
        state.inquiries = {
            items: [],
            total: 0,
        };
        state.bookings = {
            items: [],
            total: 0,
        };
    },
    [BookingsMutation.REQUEST_BOOKING](state) {
        state.status = STATUS_LOADING;
    },
    [BookingsMutation.SUCCESS_BOOKING](state) {
        state.status = STATUS_SUCCESS;
    },
    [BookingsMutation.SUCCESS_DETAIL](state, booking) {
        state.booking = booking;
        state.status = STATUS_SUCCESS;
    },
    [BookingsMutation.ERROR_BOOKING](state, error) {
        state.status = STATUS_ERROR;
        state.lastError = error;
    },
}
